import { render, staticRenderFns } from "./AppDetalhes.vue?vue&type=template&id=6c37872a&scoped=true&"
import script from "./AppDetalhes.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppDetalhes.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppDetalhes.vue?vue&type=style&index=0&id=6c37872a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c37872a",
  null
  
)

export default component.exports